<template>
    <navBar title="Ares - Various" :home="true" type="various" />
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';

    export default {
        components: {
            navBar,
        },
    }
</script>
